import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled(Container)`
  margin-bottom: 20px;
  width: 300px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;

  && button {
    width: 100%;
    max-width: none;
  }
`;

export const Error = styled.div`
  color: ${({ theme }) => theme.colors.red};
  padding: 10px 0;
  text-align: left;
  width: 100%;
`;
